import { Injectable, Injector } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class CoralProductService {
    constructor(
        private productService: ProductService,
        private injector: Injector,
    ) {}

    activateCM(): void {
        if (!this.productService.isSingleDomainApp) {
            return;
        }
        if (!this.productService.getMetadata(ClientConfigProductName.OZONE).isRegistered) {
            this.injector.get(ProductService).register(ClientConfigProductName.OZONE, this.injector);
        }
        this.productService.setActive(ClientConfigProductName.OZONE);
        /// we can write custom styles or classes injection if fails to load during host-app
    }

    deactivateCM(): void {
        if (!this.productService.isSingleDomainApp) {
            return;
        }
        this.productService.deactivateProduct(ClientConfigProductName.OZONE);
    }
}
